import { Injectable } from "@angular/core";

@Injectable()
export class Configuration {
    public Server: string;
    public BiApiServer: string;
    public BiServer: string;
    public Assinante: string;
    public PusherAppKey: string = '5528471c94af14003ea8';
    public PusherCluster: string = 'us2';
}
